import React, { useEffect } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Button from 'fe-design-base/molecules/Button/Button';
import TextField from 'fe-design-base/molecules/TextField';
import { Form } from 'formik';

import {
  EMAIL_FIELD_PLACEHOLDER,
  TEMP_EMAIL_KEY,
} from 'features/authentication/SignIn/constants';

import { toI18n } from 'util/i18n';

type Props = {
  isSubmitting: boolean;
  dirty: boolean;
  isValid: boolean;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
};
const EmailForm = ({ isSubmitting, dirty, isValid, setFieldValue }: Props) => {
  useEffect(() => {
    const initialEmail = window.sessionStorage.getItem(TEMP_EMAIL_KEY);
    if (initialEmail) {
      setFieldValue('email', initialEmail);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form role="form">
      <Box column gap={24} mt={16}>
        <TextField
          name="email"
          label={toI18n('fe_design_base.label.email')}
          startIcon="Email"
          dataTestId="EmailForm__input"
          trim
          fullWidth
          placeholder={EMAIL_FIELD_PLACEHOLDER}
        />
      </Box>
      <Box column mt={12}>
        <Button
          type="submit"
          uxElement="email code button"
          isLoading={isSubmitting}
          disabled={!dirty || !isValid}
        >
          {toI18n('fe_design_base.cta.confirm')}
        </Button>
      </Box>
    </Form>
  );
};

export default EmailForm;
